/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MinRequiredMobileVersionResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { UpdateMinRequiredMobileVersionRequest } from '../api-models';
/**
 * MobileAppVersionApi - axios parameter creator
 * @export
 */
export const MobileAppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deliberately anonymous: the app checks its version on start-up, before anyone has logged in.  Requiring a token would mean an app too old to be allowed to run still had to log in  successfully to be told so. Nothing here is specific to a facility or a user — it is the same  published version number for every caller.
         * @summary Returns the lowest app version allowed to run, as `{ \"minRequiredVersion\": \"5.0.2\" }`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileAppVersionMinRequiredGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile-app-version/min-required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stores a new minimum version and returns what was stored, so the caller can confirm the change  without a second request. Administrator-only: this value decides whether the app runs at all,  and a version above the released one stops every user from working.
         * @param {UpdateMinRequiredMobileVersionRequest} [updateMinRequiredMobileVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileAppVersionMinRequiredPut: async (updateMinRequiredMobileVersionRequest?: UpdateMinRequiredMobileVersionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile-app-version/min-required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMinRequiredMobileVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileAppVersionApi - functional programming interface
 * @export
 */
export const MobileAppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileAppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * Deliberately anonymous: the app checks its version on start-up, before anyone has logged in.  Requiring a token would mean an app too old to be allowed to run still had to log in  successfully to be told so. Nothing here is specific to a facility or a user — it is the same  published version number for every caller.
         * @summary Returns the lowest app version allowed to run, as `{ \"minRequiredVersion\": \"5.0.2\" }`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileAppVersionMinRequiredGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MinRequiredMobileVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileAppVersionMinRequiredGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stores a new minimum version and returns what was stored, so the caller can confirm the change  without a second request. Administrator-only: this value decides whether the app runs at all,  and a version above the released one stops every user from working.
         * @param {UpdateMinRequiredMobileVersionRequest} [updateMinRequiredMobileVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileAppVersionMinRequiredPut(updateMinRequiredMobileVersionRequest?: UpdateMinRequiredMobileVersionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MinRequiredMobileVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileAppVersionMinRequiredPut(updateMinRequiredMobileVersionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileAppVersionApi - factory interface
 * @export
 */
export const MobileAppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileAppVersionApiFp(configuration)
    return {
        /**
         * Deliberately anonymous: the app checks its version on start-up, before anyone has logged in.  Requiring a token would mean an app too old to be allowed to run still had to log in  successfully to be told so. Nothing here is specific to a facility or a user — it is the same  published version number for every caller.
         * @summary Returns the lowest app version allowed to run, as `{ \"minRequiredVersion\": \"5.0.2\" }`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileAppVersionMinRequiredGet(options?: AxiosRequestConfig): AxiosPromise<MinRequiredMobileVersionResponse> {
            return localVarFp.apiV2MobileAppVersionMinRequiredGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stores a new minimum version and returns what was stored, so the caller can confirm the change  without a second request. Administrator-only: this value decides whether the app runs at all,  and a version above the released one stops every user from working.
         * @param {MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileAppVersionMinRequiredPut(requestParameters: MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<MinRequiredMobileVersionResponse> {
            return localVarFp.apiV2MobileAppVersionMinRequiredPut(requestParameters.updateMinRequiredMobileVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2MobileAppVersionMinRequiredPut operation in MobileAppVersionApi.
 * @export
 * @interface MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest
 */
export interface MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest {
    /**
     * 
     * @type {UpdateMinRequiredMobileVersionRequest}
     * @memberof MobileAppVersionApiApiV2MobileAppVersionMinRequiredPut
     */
    readonly updateMinRequiredMobileVersionRequest?: UpdateMinRequiredMobileVersionRequest
}

/**
 * MobileAppVersionApi - object-oriented interface
 * @export
 * @class MobileAppVersionApi
 * @extends {BaseAPI}
 */
export class MobileAppVersionApi extends BaseAPI {
    /**
     * Deliberately anonymous: the app checks its version on start-up, before anyone has logged in.  Requiring a token would mean an app too old to be allowed to run still had to log in  successfully to be told so. Nothing here is specific to a facility or a user — it is the same  published version number for every caller.
     * @summary Returns the lowest app version allowed to run, as `{ \"minRequiredVersion\": \"5.0.2\" }`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiV2MobileAppVersionMinRequiredGet(options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiV2MobileAppVersionMinRequiredGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stores a new minimum version and returns what was stored, so the caller can confirm the change  without a second request. Administrator-only: this value decides whether the app runs at all,  and a version above the released one stops every user from working.
     * @param {MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiV2MobileAppVersionMinRequiredPut(requestParameters: MobileAppVersionApiApiV2MobileAppVersionMinRequiredPutRequest = {}, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiV2MobileAppVersionMinRequiredPut(requestParameters.updateMinRequiredMobileVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
